import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { isPc } from '../../shared-es/utils/device/device.js'
import { fetchCodeToToken, fetchUserInfo } from '@/api/user'
import { setCommon } from '@/api/fetchers'

Vue.use(VueRouter)

function formatPlatform(publish_plf) {
  switch (publish_plf) {
    case 0b01:
      return 'pc'
    case 0b10:
      return 'mobile'
    case 0b11:
      return 'all'
  }
}

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/creation',
  },
  {
    path: '/creation',
    name: 'Ugc',
    meta: {
      title: '壁纸创作中心',
    },
    component: () => import('../views/Ugc.vue'),
  },
  {
    path: '/creation/theme',
    name: 'ThemeUpload',
    meta: {
      title: '主题壁纸上传',
    },
    props: route => ({
      queryPlatform: formatPlatform(+route.query.publish_plf),
      previewJPGMobile: route.query.preview_jpg_mobile,
      mobileCrop: route.query.mobile_crop,
      resourceId: route.query.resource_id,
      resourceUrl: route.query.resource_url,
      previewJpg: route.query.preview_jpg,
      effectId: route.query.effectid,
      subWtype: +route.query.sub_wtype,
    }),
    component: () => import('../views/MobileThemeUpload.vue'),
  },
  {
    path: '/creation/video',
    name: 'DynamicUpload',
    meta: {
      title: '动态壁纸上传',
    },
    props: route => ({
      queryPlatform: route.query.platform || formatPlatform(+route.query.publish_plf),
      previewJPGMobile: route.query.preview_jpg_mobile,
      mobileCrop: route.query.mobile_crop,
      resourceId: route.query.resource_id,
      resourceUrl: route.query.resource_url,
      previewJpg: route.query.preview_jpg,
      effectId: route.query.effectid,
      subWtype: +route.query.sub_wtype,
    }),
    component: () => import('../views/DynamicPlatformUpload.vue'),
  },
  {
    path: '/creation/photo',
    name: 'StaticUpload',
    /**
     * @param {import('vue-router').Route} route
     */
    props: route => ({
      queryPlatform: route.query.platform,
    }),
    meta: {
      title: '静态壁纸上传',
    },
    component: () => import('../views/StaticPlatformUpload.vue'),
  },
  {
    path: '/contract/author',
    name: 'ContractUpload',
    meta: {
      title: '认证元气UP',
    },
    component: () => import('../views/ContractUpload.vue'),
  },
  {
    path: '/contract/painter',
    name: 'ContractPainterUpload',
    meta: {
      title: '认证画师',
    },
    component: () => import('../views/ContractPainterUpload.vue'),
  },
  {
    path: '/contract/realname',
    name: 'RealnameUpload',
    meta: {
      title: '实名认证',
    },
    component: () => import('../views/RealnameUpload.vue'),
  },
  {
    path: '/popularize/dubahuyan',
    name: 'PopularizeDubaHuyan',
    meta: {
      title: '毒霸护眼推广',
    },
    component: () => import('../views/PopularizeDubaHuyan.vue'),
  },
  {
    path: '/personal/author',
    name: 'PersonalAuthor',
    meta: {
      title: '元气壁纸-作者首页',
    },
    component: () => import('../views/Personal/Author.vue'),
  },
  {
    path: '/p',
    name: 'PersonalAuthorShort',
    meta: {
      title: '元气壁纸-作者首页',
    },
    component: () => import('../views/Personal/Author.vue'),
  },
  {
    path: '/personal/wallpaper',
    name: 'PersonalWallpaperDetail',
    meta: {
      title: '元气壁纸-壁纸详情',
    },
    component: isPc() ? resolve => require(['../views/Personal/WallpaperDetail.vue'], resolve) : resolve => require(['../views/Personal/MobileWallpaperDetail.vue'], resolve),
  },
  {
    path: '/mobileUpload',
    name: 'MobileUpload',
    meta: {
      title: '元气UP上传移动端壁纸',
    },
    component: () => import('../views/MobileUpload/MobileUpload.vue'),
  },
  {
    path: '/mobileUpload/previewVideo',
    name: 'PreviewVideo',
    meta: {
      title: '预览视频',
    },
    component: () => import('../views/MobileUpload/PreviewVideo.vue'),
  },
  {
    path: '/receiveAward',
    name: 'ReceiveAward',
    meta: {
      title: '领奖信息填写',
    },
    /**
     * @param {import('vue-router').Route} route
     */
    props: route => ({
      period: Number(route.query.period),
    }),
    component: () => import('../views/ReceiveAward.vue'),
  },
  {
    path: '/jump',
    name: 'jump',
    meta: {
      title: '签约中转',
    },
    component: () => import('../views/jump.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('../layout/creation.vue'),
      children: routes,
    },
    {
      path: '/download',
      name: 'download',
      meta: {
        title: '元气桌面壁纸',
      },
      props: route => ({
        androidChannel: route.query.android_channel,
      }),
      component: () => import('../views/download/download.vue'),
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }

  const query = to.query || {}

  if (query.dcode) {
    try {
      const res = await fetchCodeToToken({
        code: query.dcode,
      })

      if (res.resp_common && !res.resp_common.ret) {
        const common = res.data
        setCommon(res.data)
        const userInfoRes = await fetchUserInfo({
          common,
        })
        if (userInfoRes.resp_common && !userInfoRes.resp_common.ret) {
          const userInfo = userInfoRes.user_info
          store.dispatch('setUserInfo', {
            avatar: userInfo.avatar,
            nickname: userInfo.nickname,
            open_id: common.open_id,
            token: common.token,
            user_type: userInfoRes.user_type,
            wx_openid: userInfoRes.wx_openid,
          })
        }
      }
    } catch (err) {
      // TODO
    }

    delete query.dcode

    next({
      path: to.path,
      query,
    })
  }

  handleRenderBackground(to.path)

  next()
})

function handleRenderBackground(path) {
  let flag = false
  if (path.includes('personal')) {
    flag = true
  }

  if (path === '/p') {
    flag = true
  }

  const $html = document.getElementsByTagName('html')
  if ($html.length) {
    if (flag) {
      $html[0].className = ''
    } else {
      $html[0].className = 'default-wrap'
    }
  }
}

export default router
